import '/app/brewery-packages/content/content-editor-plugin-list-item/src/ListItem.css-raw';
export default {
  "listItem": "employees-21b62107-listItem-zUCuRq"
};